export default __webpack_public_path__ + "static/media/NFM_logo.48880d7d.png";